var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileMenuUpload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.50002L5.08333 5.5C3.92035 5.5 3.33886 5.50001 2.8657 5.64354C1.80037 5.96671 0.966702 6.80039 0.643535 7.86571C0.5 8.33888 0.5 8.92037 0.5 10.0833V11.8333C0.5 13.7002 0.5 14.6336 0.863312 15.3466C1.18289 15.9739 1.69282 16.4838 2.32003 16.8034C3.03307 17.1667 3.96649 17.1667 5.83333 17.1667H11.8333C13.7002 17.1667 14.6336 17.1667 15.3466 16.8034C15.9738 16.4838 16.4838 15.9739 16.8034 15.3467C17.1667 14.6336 17.1667 13.7002 17.1667 11.8333V10.0834C17.1667 8.92037 17.1667 8.33888 17.0231 7.86571C16.7 6.80039 15.8663 5.96671 14.801 5.64354C14.3278 5.50001 13.7463 5.5 12.5833 5.5L12.1667 5.50002M8.83333 0.5V13M5.5 9.66667L8.83333 13L12.1667 9.66667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileMenuUpload);
export default ForwardRef;